export default "__VITE_ASSET__BoHv9gJm__"